import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PageHeader } from 'components/header/PageHeader'

export interface EarnAssetDetailsHeaderProps {
  asset: string
  earnRate: string
  onWithdrawClick: () => void
  onDepositClick: () => void
}

export const EarnAssetDetailsHeader = ({
  asset,
  earnRate,
  onWithdrawClick,
  onDepositClick,
}: EarnAssetDetailsHeaderProps) => {
  const { t } = useTranslation()

  return (
    <PageHeader
      description={
        <Box className="text-foreground-subdued text-body-regular">
          {t('earn.assetDetailsDescription', { rate: earnRate, asset })}{' '}
          <ExternalLink href={process.env.REWARDS_HOW_IT_WORKS_URL ?? ''} target="_blank">
            {t('earn.howItWorksLink')}
          </ExternalLink>
        </Box>
      }
      renderRightSection={
        <Box flex gap={12}>
          <Button
            variant="secondary"
            onClick={onWithdrawClick}
            iconElement={<Icon name="CoinArrowOutCustom" />}
          >
            {t('earn.withdraw')}
          </Button>
          <Button onClick={onDepositClick} iconElement={<Icon name="Plus" />}>
            {t('earn.deposit')}
          </Button>
        </Box>
      }
    />
  )
}
